import React from 'react';
import GeneralTable from '../../components/Table/GeneralTable';
import { useTranslation } from "react-i18next";

export default function CostCenter(){
    const { t } = useTranslation("translation");
    
    return(
        <div>
            <GeneralTable
            table = "CostCenter"
            resourcePath="GetDetailedList"
            id ="cc_gt"
            title = {t("CostCenter")}
            search = {t("SearchCostCenter")}
            />
        </div>
    )
}